import {Directive, ElementRef, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

/**
 * После инициализации маски ввода на элементе нужно в форму записать значение, полученное в результате применения маски.
 * Это нужно для того, чтобы при обновлении полей в визарде не отваливались старые данные (не показывались с ошибкой).
 *
 * Например, у пользователя было какое-то значение в поле. Мы выкатили обновление, добавили к полю маску ввода и валидацию
 * под нее (телефон, например). Оказалось, что текущее значение не удовлетворяет валидатор (больше символов, например), так как
 * валидация была написана под маску. В итоге пользователь видит в поле значение, полученное после маски ввода,
 * а в форме лежит его старое значение и ледит до тех пор, пока пользователь не произведет ввод в поле.
 * Но пользователь не знает, что ввод нужно повторить. Он лишь видит валидное значение сейчас в поле и ошибку рядом
 * и не понимает, почему ошибка. Чтобы таких случаев не было, мы, после инициализации маски на поле, применяем полученное
 * после маски значение к форме. Если полученное значение валидно с точки зрения новой маски, то все будет хорошо,
 * если нет, то пользователю увидит уже реальную ошибку.
 */

@Directive({
    selector: '[appInputmaskInit]',
})
export class InputMaskInitDirective {
    constructor(
        private control: NgControl,
        private native: ElementRef,
    ) { /* по this.control.control доступен FormControl */ }

    @HostListener('afterInputmaskInit', ['$event']) // customFocus вызывается на элементах программно, где невозможно поймать focus нативно
    onInit() {
        /* После инициализации маски ввода обновляем значение в форме на то, которое получилось после применения маски */
        this.control.control.patchValue(this.native.nativeElement.value);
    }
}
